export default function getOrderRecipientDisplayName(order) {
  if (!order) return '';

  const parts = [order.consumer_first_name, order.consumer_last_name].filter(
    (p) => p != null && String(p).trim() !== ''
  );
  if (parts.length > 0) {
    return parts.map((p) => String(p).trim()).join(' ');
  }

  const single =
    order.consumer_name || order.recipient_name || order.destinatario_name;

  if (single != null && String(single).trim() !== '') {
    return String(single).trim();
  }

  return '';
}
